import * as React from 'react';

import classNames from 'classnames';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';

import { Button, Typography, Typography2 } from '@coursera/cds-core';

import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/video-logged-out-page';

type InputProps = {
  videoAllowance: number;
  dismissClick?: () => void;
  embeddedRegExpEnabled?: boolean;
  inFullOverlay?: boolean;
};

type Props = InputProps & {
  router: InjectedRouter;
};

const handleCTAClick = (router: InjectedRouter) => {
  router.replace({
    pathname: router.location.pathname,
    query: { ...router.location.query, authMode: 'signup', redirectTo: router.location.pathname },
  });
};

export const ContentGateContent: React.FC<Props> = ({ videoAllowance, inFullOverlay, dismissClick, router }) => {
  const contentGateClasses = classNames('vlp-gate-content', { 'in-full-overlay': inFullOverlay });

  return (
    <div className={contentGateClasses} data-unit="content-gate-content">
      <Typography variant="d2" color="invertBody" className="vlp-gate-content-title">
        {inFullOverlay
          ? _t("Like what you're learning?")
          : _t("You've finished your #{numVideoAllowance} trial videos.", { numVideoAllowance: videoAllowance })}
      </Typography>
      <Typography2 component="p" color="invertBody" className="vlp-gate-content-text">
        {inFullOverlay
          ? _t(
              "You've watched your #{numVideoAllowance} videos. Join for free and get access to unlimited course videos from top universities and leading companies.",
              { numVideoAllowance: videoAllowance }
            )
          : _t(
              'You can start developing essential skills today. Sign up on Coursera for free and take your learning to the next level.'
            )}
      </Typography2>
      <div className="vlp-gate-content-options">
        <Button
          variant="secondary"
          component={TrackedButton}
          data-unit="cg-join-for-free"
          trackingName="content_gate_join_for_free"
          className="vlp-gate-content-button vlp-gate-cta"
          onClick={() => handleCTAClick(router)}
          type="button"
          withVisibilityTracking={false}
          requireFullyVisible={false}
          aria-label={_t('Join for free')}
        >
          {_t('Join for free')}
        </Button>

        {inFullOverlay && (
          <Button
            variant="ghostInvert"
            component={TrackedButton}
            trackingName="content_gate_not_interested"
            className="vlp-gate-content-dimiss-button"
            onClick={dismissClick}
            withVisibilityTracking={false}
            requireFullyVisible={false}
            aria-label={_t('Maybe later')}
          >
            {_t('Maybe later')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default connectToRouter<Props, InputProps>((router) => ({ router }))(ContentGateContent);
